import { AUDIT_LOG_URL, get_headers } from '@/utils/constants/constants.js';
import axios from "axios";

export default {
  props: {
    status: String,
    user_id: Number,
    entity_profile_id: Number,
  },
  data: () => ({
    application_logs: [],
    loading: false,
    error: null
  }),
  computed: {
    log_filters() {
      const filters = {
        user_id: this.user_id,
        entity_profile_id: this.entity_profile_id
      };
      return filters;
    }
  },
  watch: {
    log_filters: {
      immediate: true,
      deep: true,
      handler() {
        this.fetch_application_logs();
      }
    }, 
  },
  methods: {
    async fetch_application_logs() {
      if (!this.user_id && !this.entity_profile_id) {
        this.error = 'No application ID provided';
        return;
      }

      this.loading = true;
      this.error = null;
      const params = { 
        user_id: this.user_id,
        entity_profile_id: this.entity_profile_id 
      };

      try {
        const response = await axios.get(AUDIT_LOG_URL, {
          headers: get_headers(),
          params: params
        });

        if (response?.data && Array.isArray(response.data)) {

          this.application_logs = response.data.map(log => {
            const name = log.user_full_name || log.application_name || 'System';
            const role = log.user_role && log.user_role !== 'System' ? ` (${log.user_role})` : '';
            const mapped = {
              title: log.action || log.transition_display,
              description: log.details || `Status moved from ${log.from_status_label} to ${log.to_status_label}`,
              user: `${name}${role}`,
              date: this.format_date(log.timestamp),
              time: this.formatTime(log.timestamp),
              type: log.status === 'success' ? 'success' : 'error',
            };

            return mapped;
          });

        } else {
          throw new Error('Unexpected response format');
        }
      } catch (error) {
        this.error = this.get_error_message(error);
      } finally {
        this.loading = false;
      }
    },

    format_date(timestamp) {
      const value = new Date(timestamp).toLocaleDateString();
      return value;
    },

    formatTime(timestamp) {
      const value = new Date(timestamp).toLocaleTimeString([], { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
      return value;
    },

    get_error_message(error) {

      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data?.message || 'Failed to fetch logs';
        }
      }
      return 'An unexpected error occurred.';
    }
  }
};

